import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete } from '../../components/widgets';

const AdNetworkSelection = ({
    options,
    onChange,
    containerStyle = {},
    controlledValue,
    placeHolder,
    onInputChange = () => {},
    onBlur,
    setFocus = false,
    noOptionsMessage,
    menuIsOpen,
}) => {
    return (
        <AutoComplete
            placeholder={placeHolder}
            selectOptions={{
                options,
                ...(noOptionsMessage ? { noOptionsMessage } : {}),
                ...(menuIsOpen !== undefined ? { menuIsOpen } : {}),
            }}
            onChange={onChange}
            onBlur={onBlur}
            searchable
            containerStyle={{
                width: '300px',
                ...containerStyle,
            }}
            onInputChange={onInputChange}
            controlledValue={controlledValue}
            setFocus={setFocus}
        />
    );
};

AdNetworkSelection.propTypes = {
    options: PropTypes.array,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    containerStyle: PropTypes.object,
    controlledValue: PropTypes.any,
    placeHolder: PropTypes.string,
    onInputChange: PropTypes.func,
    setFocus: PropTypes.bool,
    noOptionsMessage: PropTypes.func,
    menuIsOpen: PropTypes.bool,
};

export default AdNetworkSelection;
